import PropTypes from "prop-types";
import { useState } from "react";
import { Button, Col, Image, Row } from "react-bootstrap";
import {
  AddSubIcon,
  DeleteIcon,
  EditIcon,
  ListPlusIcon,
  OverflowMenuIcon,
  PreviewIcon
} from "../data/iconImage";
import ButtonLink from "./ButtonLink";
import ConfirmModal from "./ConfirmModal";

const ButtonOptionSubmenu = ({
  data,
  state = { add: null, addsub: null, edit: null, delete: null, preview: null },
  iconProp,
  style,
  isDisabled,
  previewButton,
  addButton,
  addSubButton,
  editButton,
  deleteButton,
  onDeleteCallback,
  showDeleteButton,
  hideMoreButton
}) => {
  const [showModal, setShowModal] = useState(false);
  const [showButtons, setShowButtons] = useState(false);

  return (
    <Row className="ButtonSubmenu">
      <Col className={showButtons ? "w-auto visible" : "p-0 invisible"}>
        {previewButton && (
          <ButtonLink
            linkTo={previewButton?.link || "preview"}
            stateData={state?.preview}
            buttonColor="light"
            buttonClass="p-2 bg-light bg-opacity-0 border-light border-opacity-0 rounded-circle"
            iconSrc={iconProp?.preview?.iconSrc || PreviewIcon}
            iconName={iconProp?.preview?.iconName || "Preview Icon"}
            isDisabled={isDisabled?.preview}
            style={style?.preview}
          />
        )}

        {addButton && (
          <ButtonLink
            linkTo=""
            stateData={state?.add}
            buttonClass="mx-2 p-2 bg-light bg-opacity-0 border-light border-opacity-0 rounded-circle "
            iconSrc={iconProp?.add?.iconSrc || ListPlusIcon}
            iconName={iconProp?.addsub?.iconName || "ListPlus Icon"}
            isDisabled={isDisabled?.add}
            style={style?.add}
          />
        )}

        {addSubButton && (
          <ButtonLink
            linkTo={state?.addsub?.to || "sub"}
            stateData={state?.addsub}
            buttonColor="light"
            buttonClass="mx-2 p-2 bg-light bg-opacity-0 border-light border-opacity-0 rounded-circle "
            iconSrc={iconProp?.addsub?.iconSrc || AddSubIcon}
            iconName={iconProp?.addsub?.iconName || "AddSub Icon"}
            isDisabled={isDisabled?.addsub}
            style={style?.addsub}
          />
        )}

        {editButton && (
          <ButtonLink
            linkTo={`${data.Id}`}
            stateData={state?.edit}
            buttonClass="ms-2 p-2 bg-success bg-opacity-50 border-success border-opacity-50 rounded-circle"
            iconSrc={iconProp?.edit?.iconSrc || EditIcon}
            iconName={iconProp?.edit?.iconName || "Edit Icon"}
            isDisabled={isDisabled?.edit}
            style={style?.edit}
          />
        )}

        {deleteButton && (
          <>
            <Button
              variant="light"
              className="ms-2 p-2 bg-light bg-opacity-0 border-light border-opacity-0 rounded-circle"
              onClick={() => setShowModal(!showModal)}
              disabled={isDisabled?.delete}
              style={style?.delete?.button}
            >
              <Image
                src={iconProp?.delete?.iconSrc || DeleteIcon}
                alt={iconProp?.delete?.iconName || "Delete Icon"}
                style={style?.delete?.img}
              />
            </Button>
            <ConfirmModal
              show={showModal}
              data={data}
              content="delete"
              onSubmitCallback={(event, { dataCallback, showCallback }) => {
                if (dataCallback) onDeleteCallback(event, dataCallback);
                setShowModal(showCallback);
              }}
            />
          </>
        )}
      </Col>
      {showDeleteButton && (
        <>
          <Button
            variant="light"
            className="ms-2 p-2 bg-light bg-opacity-0 border-light border-opacity-0 rounded-circle"
            onClick={() => setShowModal(!showModal)}
            disabled={isDisabled?.delete}
            style={style?.delete?.button}
          >
            <Image
              src={iconProp?.delete?.iconSrc || DeleteIcon}
              alt={iconProp?.delete?.iconName || "Delete Icon"}
              style={style?.delete?.img}
            />
          </Button>
          <ConfirmModal
            show={showModal}
            data={data}
            content="delete"
            onSubmitCallback={(event, { dataCallback, showCallback }) => {
              if (dataCallback) onDeleteCallback(event, dataCallback);
              setShowModal(showCallback);
            }}
          />
        </>
      )}
      {hideMoreButton ? (
        <></>
      ) : (
        <Button
          variant="light"
          className="w-auto p-1 bg-light bg-opacity-0 border-0"
          onClick={() => setShowButtons(!showButtons)}
        >
          <Image src={OverflowMenuIcon} alt="Overflow Menu Icon" />
        </Button>
      )}
    </Row>
  );
};

ButtonOptionSubmenu.propTypes = {
  data: PropTypes.object.isRequired,
  state: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  style: PropTypes.object,
  iconProp: PropTypes.object,
  isDisabled: PropTypes.object,
  previewButton: PropTypes.bool,
  addButton: PropTypes.bool,
  addSubButton: PropTypes.bool,
  editButton: PropTypes.bool,
  deleteButton: PropTypes.bool,
  onDeleteCallback: PropTypes.func,
  showDeleteButton: PropTypes.bool,
  hideMoreButton: PropTypes.bool
};

export default ButtonOptionSubmenu;
